export const browserStorageKey = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  BACKUP_URL: 'backupUrl',
  LAST_KNOWN_LANGUAGE: 'lastKnownLanguage',
  ALPHA_CATALOGUE_VERSION: 'alphaCatalogueVersion',
  CURRENT_VERSION: 'currentVersion',
  PERMISSIONS: 'userPermissions',
  SALES_ACTIVITY_PANEL_OPEN: 'salesActivityPanelOpen',
  LAST_PROMO_FEATURE_SEEN: 'lastPromoFeatureSeen',
  AI_ASSISTANT_DAILY_DIGEST_DISMISSED_ON: 'aiAssistantDailyDigestDismissedOn',
  AI_ASSISTANT_NUDGE_STATE: 'aiAssistantNudgeState',
  AI_ASSISTANT_VIEW_MODE: 'aiAssistantViewMode',
  AI_ASSISTANT_SIDEBAR_WIDTH: 'aiAssistantSidebarWidth',
  ACTIVITY_PANEL_WIDTH: 'activityPanelWidth',
  GLOBAL_SEARCH_GROUP_MODE: 'globalSearchGroupMode',
  GLOBAL_SEARCH_FILTERS: 'globalSearchFilters',
  GLOBAL_SEARCH_RECENTS: 'globalSearchRecents',
  RENTAL_CALENDAR_FILTERS: 'rentalCalendarFilters',

  // IAM TOKENS INIT ---------------------------
  PENDING_ACCESS_TOKEN: 'pending_access_token',
  PENDING_REFRESH_TOKEN: 'pending_refresh_token',

  // DO NOT TOUCH: DEV SETTINGS ---------------------------
  CI_MODE: 'cimode',
  MOCK_FLAGS_KEY: 'featureFlagMock',
  APP_UPDATE_SIMULATION: 'appUpdateSimulation',
  DEV_SETTINGS_SIDEBAR_STATE: 'devSettingsSidebarState',
  DISABLE_MANDATORY_FIELDS_VALIDATION: 'disableMandatoryFieldsValidation',
  PERFORMANCE_TRACKING_ENABLED: 'performanceTrackingEnabled',
  AI_ASSISTANT_STORE_LOGGING_ENABLED: 'aiAssistantStoreLoggingEnabled',
  WORKTREE_NAME: 'worktreeName',
};
